import { clone, setWith } from 'lodash';

const setIn = (object, path, value) => setWith(clone(object), path, value, clone);

export default setIn;
